import { Button, Stack, Typography } from '@mui/material';
import type { ReactNode } from 'react';
import { Component } from 'react';

interface ErrorBoundaryProps {
  children: ReactNode;
  onRetry?: () => void;
}
interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error;
}

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    return { hasError: true, error };
  }
  componentDidCatch(error: Error, info: any) {
    console.error('ErrorBoundary caught', error, info);
  }
  handleRetry = () => {
    this.setState({ hasError: false, error: undefined });
    this.props.onRetry?.();
  };
  render() {
    if (this.state.hasError) {
      return (
        <Stack gap={2} p={2} alignItems='flex-start'>
          <Typography color='error'>Đã xảy ra lỗi khi tải nội dung.</Typography>
          <Button variant='outlined' onClick={this.handleRetry}>
            Thử lại
          </Button>
        </Stack>
      );
    }
    return this.props.children;
  }
}
